export default "__VITE_ASSET__7f404b65__"